import { render, staticRenderFns } from "./certIframe.vue?vue&type=template&id=a3356390&scoped=true&"
import script from "./certIframe.vue?vue&type=script&lang=js&"
export * from "./certIframe.vue?vue&type=script&lang=js&"
import style0 from "./certIframe.vue?vue&type=style&index=0&id=a3356390&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3356390",
  null
  
)

export default component.exports